import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Expenses from "./pages/Expenses";
import Budgets from "./pages/Budgets";
import Settings from "./pages/Settings";
import Layout from "./components/Layout";
import Income from "./pages/Income";
import Goals from "./pages/Goals";
import Coach from "./pages/Coach";
import Upgrade from "./pages/Upgrade";
import BillingSuccess from "./pages/BillingSuccess";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Landing from "./pages/Landing";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center font-mono text-sm" data-testid="auth-loading">
        LOADING…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

// Root route: authenticated users get Dashboard, guests get marketing Landing.
function HomeRoute() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) {
    return (
      <Layout>
        <Dashboard />
      </Layout>
    );
  }
  return <Landing />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/reset-password" element={<PublicOnly><ResetPassword /></PublicOnly>} />
            <Route path="/" element={<HomeRoute />} />
            <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
            <Route path="/income" element={<Protected><Income /></Protected>} />
            <Route path="/goals" element={<Protected><Goals /></Protected>} />
            <Route path="/coach" element={<Protected><Coach /></Protected>} />
            <Route path="/upgrade" element={<Protected><Upgrade /></Protected>} />
            <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
            <Route path="/budgets" element={<Protected><Budgets /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid #111111",
              fontFamily: "IBM Plex Mono, monospace",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}
